<div class="outer-content">
  <div *ngIf="displayPage" role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true" class="wh-auto">
    <div class="float-left bg-white card-background wh-auto">
      <form [formGroup]="addMCForm" autocomplete="off" role="form" class="fieldHeight">
        <app-content-top-nav [closeBtnEnabled]="true" [visibleBackNav]='true' [enableBackNav]='true'
          (onCloseClickHandler)="closePage()"></app-content-top-nav>
        <div class="col-md-12 clear-all title-wrapper margin-bottom-50">
          <h1 class="title-text custom-header-h2 responsive-text-8" id="addMedicalCondition-header">{{contentData.header}}</h1>
        </div>
        <div class="col-md-12 clear-all content-wrapper">
            <p class="to-give-you-the-best" id="addMedicalCondition-subTitle" *ngIf="dependantFlag">
              <b>{{contentData.subTitle}}</b>
            </p>
          <p class="to-give-you-the-best" id="addMedicalCondition-introduction">
            {{contentData.introduction}}
          </p>
          <div *ngIf="MCExist" class="col-md-12 clear-all mt-30 bg-lightblue">
            <!-- <p class="inner-content-data" id="gYOQ-secureStatement">{{contentData.secureStatement}}</p>
            <p class="inner-content-data" id="gYOQ-definedBenefitPension">{{contentData.definedBenefitPension}}</p> -->
            <p class="inner-content-data" [innerHTML]="contentData.MCExist"></p>
          </div>
          <div class="col-md-12 clear-all mt-50 flex-container" *ngIf="radioBtnQuestionObj">
            <app-radio-button-dot [config]="radioBtnQuestionObj" [parent]="addMCForm"
              [parentControlName]="'radioBtnForMCList'" [defaultSelectedValue]="radioBtnDefaultValue"
              (selectedValueEmitterRadBtn)="onChangeOfRadioBtn($event)"
              [radioList]="prepareListForRadioStad(radioBtnQuestionObj)"></app-radio-button-dot>
          </div>

          <div *ngIf="errorText" class="col-md-12 form-validation-error mt-30">
            <i aria-hidden="true" class="icon icon-error"></i>
            <p aria-hidden="false" aria-live="polite" role="error" id="letterPack-error">
              {{errorText}}
            </p>
          </div>
        </div>

        <div class="col-md-12 underline margin-top"></div>
        <div class="col-md-12 clear-all">
          <div class="float-right">
            <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']"
              [buttonType]="'normalCTA'"></app-content-bottom-nav>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>